"use client"

import { X, User } from "lucide-react"

const ViewFaculty = ({ faculty, setViewingFaculty, isProfile = false }) => {
  // Helper to format date or return 'N/A'
  const formatDate = (dateString) => {
    if (!dateString) return "N/A"
    try {
      return new Date(dateString).toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      })
    } catch {
      return "N/A"
    }
  }

  // Data map for easy rendering and alignment
  const facultyData = [
    { label: "Employee ID", value: faculty.employee_id },
    { label: "Faculty Code", value: faculty.faculty_code },
    { label: "Institute", value: faculty.department_name },
    { label: "Designation", value: faculty.designation },
    { label: "Email", value: faculty.email },
    { label: "Mobile", value: faculty.phone  },
    { label: "Qualification", value: faculty.qualification },
    { label: "Experience (Years)", value: faculty.experience_years },
    { label: "Joining Date", value: formatDate(faculty.joining_date) },
    { label: "Employment Status", value: faculty.employment_status || "Pending Review" },
  ]

  return (
    <div className="relative bg-white dark:bg-gray-800 p-8 rounded-xl shadow-2xl border border-gray-100 dark:border-gray-700 max-w-3xl mx-auto w-full">
      {/* Close Button - Hidden in profile view */}
      {!isProfile && (
        <button
          onClick={() => setViewingFaculty(null)}
          className="absolute top-4 right-4 p-2 text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white transition-colors rounded-full hover:bg-gray-100 dark:hover:bg-gray-700"
          aria-label="Close"
        >
          <X className="w-6 h-6" />
        </button>
      )}

      {/* Header Section */}
      <div className="flex items-center space-x-4 mb-8 border-b pb-4 border-gray-200 dark:border-gray-700">
        <div className="flex-shrink-0 w-20 h-20 rounded-full bg-blue-100 dark:bg-blue-900 flex items-center justify-center text-blue-600 dark:text-blue-300 ring-4 ring-blue-500/20">
          {/* Placeholder for Profile Image */}
          {/* In a real app, you'd replace this with an <img> tag */}
          <User className="w-10 h-10" />
        </div>
        <div className="flex-grow">
          <h3 className="text-3xl font-bold text-gray-900 dark:text-white">
            {faculty.name || "Faculty Member"}
          </h3>
          <p className="text-md text-blue-600 dark:text-blue-400 font-medium">
            {isProfile ? "Personal Profile" : "Detailed Information"}
          </p>
        </div>
      </div>

      {/* Details Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-6">
        {facultyData.map((item, index) => (
          <div key={index} className="flex flex-col">
            <label className="block text-sm font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
              {item.label}
            </label>
            <p className="mt-1 text-base font-semibold text-gray-800 dark:text-gray-200 break-words">
              {item.value || "N/A"}
            </p>
          </div>
        ))}
      </div>

      {/* Footer / Close Button for non-profile view */}
      {!isProfile && (
        <div className="flex justify-end mt-8 pt-4 border-t border-gray-200 dark:border-gray-700">
          <button
            onClick={() => setViewingFaculty(null)}
            className="px-6 py-2 text-white bg-blue-600 hover:bg-blue-700 dark:bg-blue-700 dark:hover:bg-blue-600 font-medium rounded-lg shadow-md transition-all duration-200"
          >
            Done
          </button>
        </div>
      )}
    </div>
  )
}

export default ViewFaculty